export const isLoading = (state, actionName) => !!state.loaders.actions.find(a => a === actionName);
